module.exports = __webpack_public_path__ + "img/dog.be5030ca.webp";